import { compose } from 'recompose';
import SelectInput from '@/se/components/inputs/SelectInput';
import { list } from '@/graph/config';
import { ConfigType } from '@/types/HospitalConfig';
import React from 'react';
import { useQuery } from '@apollo/client';
import { withLabel } from '@/se/components/Label';

const LabeledSelectInput = compose(withLabel('Department'))(SelectInput);

const DepartmentSelectInput = ({ value, onChange }) => {
  const { data } = useQuery(list, {
    variables: {
      type: ConfigType.StaffDepartment,
    },
  });

  const options = data?.configs?.reduce((acc, curr) => {
    const parsed = curr?.values && JSON.parse(curr?.values);
    return parsed?.name ? { ...acc, [parsed.name]: parsed.name } : acc;
  }, {});

  return (
    <LabeledSelectInput
      /* @ts-ignore */
      placeholder={'e.g., Pre-Op'}
      required={false}
      value={value}
      onChange={onChange}
      options={options}
    />
  );
};

export default DepartmentSelectInput;
